<template>
  <div>
    <span class="header_text q-ml-lg" v-if="title">
      {{ title }}
    </span>
    <q-separator class="q-mt-md" v-if="title"></q-separator>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .header_text {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
  }
</style>
